import { render } from "./IotProduct.vue?vue&type=template&id=130e596e&scoped=true"
const script = {}

import "./IotProduct.vue?vue&type=style&index=0&id=130e596e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-130e596e"]])

export default __exports__